export default "__VITE_ASSET__CIHBpVl0__"